import { render, staticRenderFns } from "./LicensesTable.vue?vue&type=template&id=496a7661&"
import script from "./LicensesTable.vue?vue&type=script&lang=js&"
export * from "./LicensesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports